<template>
    <div>
        <card-header title="Application" icon="fa-file-certificate"/>

        <template>
            <card-toolbar>
                <button @click="$openCard('conf-edit-app', {confId: props.confId, appId: app.id}, card)"><i class="far fa-pencil"></i>Edit Settings</button>
            </card-toolbar>

            <card-body>
                <card-list>
                    <container-list-item v-if="loaded">
                        <data-row title="Application">{{ application.title }}</data-row>
                        <data-row title="Certification">{{ application.certification_certs.title }}</data-row>
                        <data-row title="Certification">{{ application.certification_certs.certifications.title }}</data-row>
                        <data-row title="Type">{{ application.certification_certs.certifications.type.replace('cert','Certification').replace('unit', 'Units') }}</data-row>
                        <data-row title="Conference">{{conference.title}}</data-row>
                        <data-row title="Visible"><i class="fas fa-check mr-2 has-text-success" v-if="app.is_active"></i><i class="fas fa-ban mr-2 has-text-warning" v-else></i></data-row>
                        <data-row title="Enabled"><i class="fas fa-check mr-2 has-text-success" v-if="app.is_enabled"></i><i class="fas fa-ban mr-2 has-text-warning" v-else></i></data-row>
                        <data-row title="Approved" v-if="app.applications.is_require_approval"><i class="fas fa-check mr-2 has-text-success" v-if="app.is_approved"></i><i class="fas fa-ban mr-2 has-text-warning" v-else></i></data-row>
                        <data-row title="Required"><i class="fas fa-check mr-2 has-text-success" v-if="app.is_required_at_end"></i><i class="fas fa-ban mr-2 has-text-warning" v-else></i></data-row>
                        <data-row title="Max Units" v-if="application.certification_certs.certifications.type === 'units'">{{app.max_units}}</data-row>
                        <data-row title="Min Minutes">{{app.min_minutes_required}}</data-row>
                        <data-row title="Min Sessions">{{app.min_sessions_required}}</data-row>
                    </container-list-item>

<!--                    <separator-list-item/>-->

<!--                    <navigation-list-item-->
<!--                        title="Application Evaluation Summary"-->
<!--                        icon="fa-sparkles"-->
<!--                        @click="$openCard('conf-app-summary', {confId: props.confId, appId: app.application_id}, card)"-->
<!--                        :active="(child && child.definition.component === 'conf-app-summary')"-->
<!--                    />-->

                    <subheader-list-item title="Applicants" icon="fa-cogs" :badge="applicants.length"/>

                    <applicant-tile
                        :applicant="applicant"
                        :card="card"
                        v-for="applicant in applicants"
                        @click="$openCard('application-applicant', {applicantId: applicant.id, applicationId: applicant.conf_applications.application_id, applicantType: applicant.type}, card)"
                        :active="(child && child.definition.component === 'application-applicant' && applicant.id === parseInt(child.props.applicantId))"
                    />

                </card-list>
            </card-body>
        </template>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import RmcConfTile from "@/components/rmc/RmcConfTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import async from "async";
    import ApplicantTile from "../../../components/tiles/ApplicantTile.vue";

    export default {
        props: ['card', 'child', 'props'],
        components: {ApplicantTile, ContainerListItem, SeparatorListItem, RmcConfTile, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                loaded: false,
                app: {},
                conference: {},
                application: {},
                applicants: [],
            };
        },
        methods: {
            loadApp: function() {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/applications/' + this.props.appId, {force: true}).then(response => {
                    this.app = response.data;

                    http.get('applicants/application/' + this.app.application_id + '/conf/' + this.app.conference_id, {force: true}).then(response => {
                        this.conference = response.data[0].conferences;
                        this.application = response.data[0].applications;
                        let applicants = response.data[0].reg_applications;

                        for (let j = 0; j < applicants.length; j++) {
                            const regApplication = applicants[j];

                            this.applicants.push({
                                type: 'conf',
                                ...regApplication,
                                conference: this.conference
                            });
                        }

                        // sort this.applicants array by users.last_name
                        this.applicants.sort((a, b) => {
                            if (a.users.last_name < b.users.last_name) return -1;
                            if (a.users.last_name > b.users.last_name) return 1;
                            return 0;
                        });

                        this.$emit('loading', false);
                        this.loaded = true;
                    }).catch(err => {

                    });

                }).catch(err => {

                });
            },
            reload: function() {
                this.loadApp(true);
            }
        },
        watch: {
            'props.appId': function() {
                this.loadApp();
            }
        },
        mounted: function() {
            this.loadApp();
        }
    };
</script>

